// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1T0KE","colBig":"styles_colBig__S_Rys","colSmall":"styles_colSmall__1YHwY","shopifyNameWrapper":"styles_shopifyNameWrapper__1fC_Z"};